import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {MessageService} from '../message.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CustomInputEditor} from '../custom-inputEditor';
import {CommonSlickgridComponent} from '../common-slickgrid/common-slickgrid.component';
import {RestApiService} from '../rest-api.service';
import {Editors, FieldType, Formatters} from 'angular-slickgrid';
import {NotifierService} from 'angular-notifier';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-module-client',
  templateUrl: './module-client.component.html',
  styleUrls: ['./module-client.component.css']
})
export class ModuleClientComponent implements OnInit, OnDestroy {

  displayed = true;
  sDate: string;
  eDate: string;
  totalData = 0;
  show: boolean;
  selected: number;
  clientSelected: number;
  clients: any;
  moduleSelected: number;
  modules: any;
  sequence: string;
  isChecked = false;
  private respObject: any;
  private moduleName: string | string;
  private clientName: any;

  min: any;
  max: any;

  displayData: any;

  add: boolean;
  del: boolean;
  edit: boolean;
  view: boolean;

  isError = false;
  errorMessage: string;

  private notifier: NotifierService;
  slideChecked = false;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private adminAuth: Subscription;
  private baseFlag: any;
  clientId: number;
  offset: number;
  dataLoaded:boolean;
  constructor(private _rest: RestApiService,
              private messageService: MessageService, private route: Router, private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      switch (item.type) {
        case 'change':
          // console.log('changed');
          if (!this.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {

          }
          break;
        case 'delete':
          if (!this.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
              this._rest.deleteMapModuleWithClient({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                this.respObject = res;
                // console.log(JSON.stringify(this.respObject));
                if (this.respObject.success) {
                  this.messageService.sendAfterDelete(item.id);
                } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
                }
              }, (err) => {
                this.notifier.notify('error', this.respObject.errorMessage);
              });
            }
          }
          break;
      }
    });
    this.messageService.getUserAuth().subscribe(details => {
      // console.log(JSON.stringify(details));
      if (details.length > 0) {
        this.add = details[0].addFlag;
        this.del = details[0].deleteFlag;
        this.view = details[0].viewFlag;
        this.edit = details[0].editFlag;
      } else {
        this.add = false;
        this.del = false;
        this.view = false;
        this.edit = false;
      }
    });
    this.messageService.getSelectedItemData().subscribe(selectedTitles => {
      if (selectedTitles.length > 0) {
        this.show = true;
        this.selected = selectedTitles.length;
      } else {
        this.show = false;
      }
    });
  }

  ngOnInit() {
    this.dataLoaded=false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.displayData = {
      pageName: 'View Module Client Mapping',
      openModalButton: 'Map Module with Client',
      breadcrumb: 'ModuleClientMapping',
      folderName: 'All Mappings',
      tabName: 'Module Client Mappings'
    };

    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
      {
        id: 'client', name: 'Client Name', field: 'client', sortable: true, filterable: true
      },
      {
        id: 'name', name: 'Module Name', field: 'module', sortable: true, filterable: true
      },
      {
        id: 'startDate',
        name: 'Start Date',
        field: 'startDate',
        sortable: true,
        type: FieldType.date,
        filterable: true,
        cssClass: 'highlight',
        editor: {model: Editors.date}
      },
      {
        id: 'endDate',
        name: 'End Date',
        field: 'endDate',
        sortable: true,
        type: FieldType.date,
        filterable: true,
        cssClass: 'highlight',
        editor: {model: Editors.date}
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    this._rest.getClient().subscribe((res) => {
      this.respObject = res;
      // console.log(JSON.stringify(this.respObject.clients));
      if (this.respObject.success) {
        this.respObject.clients.unshift({id: 0, name: 'Select Client'});
        this.clients = this.respObject.clients;
        this.clientSelected = 0;
      } else {

      }
    }, function (err) {

    });
    this._rest.getModules().subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.respObject.modules.unshift({id: 0, MODULENAME: 'Select Module'});
        this.modules = this.respObject.modules;
        this.moduleSelected = 0;
      } else {

      }
    }, function (err) {

    });
    // this.moduleSelected = 0;
    this.sDate = '';
    this.eDate = '';
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
        if (details.length > 0) {
          this.add = details[0].addFlag;
          this.del = details[0].deleteFlag;
          this.view = details[0].viewFlag;
          this.edit = details[0].editFlag;
          this.clientId = details[0].clientId;
          this.baseFlag = details[0].baseFlag;
          this.onPageLoad();
        }
      });
    }
  }

  onPageLoad() {
    this.getTableData();
  }

  openModal(content) {
    if (!this.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.moduleSelected = 0;
      this.clientSelected = 0;
      this.isError = false;
      this.sDate = '';
      this.eDate = '';
      this.sequence = '';
      this.isChecked = false;
      this.modalService.open(content, {size: 'sm'}).result.then((result) => {
      }, (reason) => {

      });
    }
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  save() {
    if (this.sDate === null) {
      this.sDate = '';
    }
    const data = {
      moduleId: this.moduleSelected,
      sequence: this.sequence,
      clientId: this.clientSelected,
      startDate: this.sDate,
      autoConfigure: this.isChecked
    };

    if (!this.slideChecked) {
      if (this.eDate === null) {
        this.eDate = '';
      }
      data['endDate'] = this.eDate;
    } else {
      this.eDate = '';
    }
   // console.log("data------"+JSON.stringify(data));
    if (!this.messageService.isBlankField(data)) {
      this._rest.mapModuleWithClient(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.totalData = this.totalData + 1;
          this.messageService.setTotalData(this.totalData);
          this.isError = false;
          const id = this.respObject.id;
          if(this.eDate !== ''){
            this.eDate = this.messageService.datePipeFunc(this.eDate);
          }
          this.messageService.setRow({
            id: id,
            client: this.clientName,
            module: this.moduleName,
            startDate:this.messageService.datePipeFunc(this.sDate),
            endDate:  this.eDate
          });
          if (this.totalData <= this.pageSize * this.page_no) {
              this.offset = id;
              this.nextOffset = 0;
          } else {
              this.nextOffset = this.offset;
          }
          this.moduleSelected = 0;
          this.clientSelected = 0;
          this.isChecked = false;
          this.sDate = '';
          this.eDate = '';
          this.sequence = '';
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  slideChange() {
    this.slideChecked = !this.slideChecked;
  }

  getTableData() {
    if (!this.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
      this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded=false;
    this._rest.getMappedModule(offset, this.pageSize, paginationType).subscribe((res) => {
      this.respObject = res;
      this.executeResponse(this.respObject, offset, paginationType);
    }, function (err) {
      console.log(err);
    });
  }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
          this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.modules.totalData[0].count;
                this.totalPage = respObject.modules.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.modules.dataObj)) {
                for (let i = 0; i < respObject.modules.dataObj.length; i++) {
                    respObject.modules.dataObj[i].startDate =
                        this.messageService.datePipeFunc(respObject.modules.dataObj[i].startDate);
                    if (respObject.modules.dataObj[i].endDate !== null && respObject.modules.dataObj[i].endDate !== '') {
                        respObject.modules.dataObj[i].endDate =
                            this.messageService.datePipeFunc(respObject.modules.dataObj[i].endDate);
                    }
                }
                const data = respObject.modules.dataObj;
                this.nextOffset = respObject.modules.nextOffset;
                this.offset = respObject.modules.nextOffset;
                this.previousOffset = respObject.modules.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.modules.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.modules.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }


  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  onModuleChange(value: any) {
    this.moduleName = this.modules[value].MODULENAME;
  }

  onClientChange(value: any) {
    this.clientName = this.clients[value].name;
    const startDate = new Date(this.clients[value].startDate).setHours(0, 0, 0, 0);
    this.min = new Date(startDate);
    if (this.clients[value].endDate !== null) {
      const endDate = new Date(this.clients[value].endDate).setHours(23, 59, 59, 999);
      this.max = new Date(endDate);
    }
    // console.log(this.min, this.max);
  }

  ngOnDestroy(): void {
    if (this.adminAuth) {
      this.adminAuth.unsubscribe();
    }
  }
}
